import { hasCornerCore } from "./index22.js";
import { BoneSide, EntryLocation, GetAllBones } from "@project-rouge/rg-core";
const CalcAnatomyEntrances = (joint) => {
	const bones = GetAllBones(joint);
	let entranceCount = 0;
	for (const b of bones) if (b.entrySide) {
		const muscle = b.muscles[b.entrySide];
		if (muscle.flip) if (b.entryLocation === EntryLocation.Start) muscle.entry = EntryLocation.End;
		else if (b.entryLocation === EntryLocation.End) muscle.entry = EntryLocation.Start;
		else muscle.entry = EntryLocation.Middle;
		else muscle.entry = b.entryLocation;
		entranceCount++;
	}
	for (const bone of bones) {
		if (bone.loads[BoneSide.Right] && hasCornerCore({
			bone,
			right: false,
			start: true
		})) {
			bone.muscles.find((m) => m.side === BoneSide.Right).entry = EntryLocation.Start;
			entranceCount++;
		}
		if (bone.loads[BoneSide.Left] && hasCornerCore({
			bone,
			right: true,
			start: false
		})) {
			bone.muscles.find((m) => m.side === BoneSide.Left).entry = EntryLocation.Start;
			entranceCount++;
		}
	}
	if (!entranceCount) bones[0].muscles[0].entry = EntryLocation.Middle;
};
export { CalcAnatomyEntrances };

//# sourceMappingURL=index173.js.map